var exports = {
  "L": "AvatarDecorationOverlay.module__overlay___R19XM1",
  "S": "AvatarDecorationOverlay.module__image___R19XM1",
};

module.exports = exports;
